export default __webpack_public_path__ + "static/media/Emotion_Other.cd4726e4.svg";